// SchoolSearch.js
import React, { useState } from 'react';

const SchoolSearch = ({ subcategories }) => {
  const [showRingMenu, setShowRingMenu] = useState(false);

  return (
    <div className="dropdown-menu school-form-dropdown">
      <h5>Shop My School</h5>
      <p>Search Your School to Find 1,000s of Items Curated For You!</p>
      <input
        type="text"
        className="form-control"
        placeholder="School Name, City, State, or ZIP"
      />
      <button className="btn btn-primary mt-3 w-100">Search</button>
      {showRingMenu && (
        <div className="ring-menu mt-3">
          <h5>Design Your Class Ring</h5>
          <ul>
            {subcategories.map((subItem, subIndex) => (
              <li key={subIndex}>
                <a className="dropdown-item" href={subItem.href}>
                  {subItem.category}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SchoolSearch;